// This is used to sanitize filenames when uploading files to avoid issues with ModSecurity WAF False Positives
// The WAF only runs on staging and production environments so this is not a problem in development

import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filename-sanitize"
export default class extends Controller {
  initialize() {
    this.onChange = this.sanitize.bind(this)
  }

  connect() {
    this.element.addEventListener("change", this.onChange)
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange)
  }

  sanitize(event) {
    const dt = new DataTransfer()

    for (const file of event.target.files) {
      const cleanedName = this.clean(file.name)
      dt.items.add(new File(
        [file],
        cleanedName,
        { type: file.type, lastModified: file.lastModified }
      ))
    }

    this.element.files = dt.files
  }

  // allow letters, numbers, dot, dash, underscore; replace everything else with “_”
  clean(name) {
    return name
      // strip control chars that can break headers
      .replace(/[\x00-\x1F\x7F]/g, "")
      // collapse path separators
      .replace(/[\/\\]/g, "_")
      // replace quotes, semicolons → ModSecurity IQ / SM
      .replace(/[\'\";]/g, "_")
      // normalise whitespace
      .replace(/\s+/g, "_")
      // anything still weird
      .replace(/[^A-Za-z0-9._-]/g, "_")
      // keep it sensible length
      .slice(0, 255)
  }
}
